'use client';

import { Button } from '@common/components';
import { cn } from '@core/utils';
import { useRef, useState } from 'react';
import { Transition } from 'react-transition-group';

interface ContentContainerProps {
  className?: string;
  children: React.ReactNode;
}

export const ContentContainer = ({
  children,
  className,
}: ContentContainerProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);
  const articleRef = useRef<HTMLElement>(null);
  const [height, setHeight] = useState(0);

  return (
    <Transition in={isOpen} nodeRef={articleRef} timeout={150}>
      {(state) => {
        return (
          <article
            ref={articleRef}
            className={cn(
              'relative transition-[height] animate-ease-in',
              {
                'overflow-hidden': state !== 'entered',
              },
              className,
            )}
            style={{
              height: isOpen ? height + 96 : 300,
            }}
          >
            <div ref={ref} className="flex flex-col gap-40">
              {children}
            </div>

            {/* 채널톡 z-index 9라서 z-8로 설정 */}
            <div
              className={cn(
                isOpen
                  ? 'mt-40'
                  : [
                      'absolute bottom-0 z-[8] w-full pt-96',
                      'bg-gradient-to-t from-Gray-white to-transparent',
                    ],
              )}
            >
              <div className="w-full bg-Gray-white">
                <Button
                  className="w-full"
                  dimensions="H48"
                  theme="sub-line"
                  onClick={() => {
                    if (ref.current) {
                      setHeight(ref.current.clientHeight);
                    }

                    setIsOpen((prev) => !prev);
                  }}
                >
                  {isOpen ? '접기' : '상세 내용 더보기'}
                </Button>
              </div>
            </div>
          </article>
        );
      }}
    </Transition>
  );
};
